import api from "./api.service";

const unwrap = (response) => {
  const body = response && response.data;
  return body && Object.prototype.hasOwnProperty.call(body, "data")
    ? body.data
    : body;
};

export const listKioskGroups = (params = {}) => (
  api.get("/kioskOperaciones/grupos", { params }).then(unwrap)
);

export const listKioskCalendars = (params = {}) => (
  api.get("/kioskOperaciones/calendarios", { params }).then(unwrap)
);

export const getKioskMonitoringSummary = (params = {}) => (
  api.get("/kioskOperaciones/dashboard/summary", { params }).then(unwrap)
);

export const getKioskWorkerReport = (sessionId) => (
  api.get(`/kioskOperaciones/sessions/${sessionId}/report`).then(unwrap)
);
